/**
 * Enterprise workspace site options — same catalog as /admin/inspections/site/
 * via GET /api/sites/.
 */

/** Fallback when /api/sites/ is unavailable. */
export const FALLBACK_ENTERPRISE_SITES = Object.freeze([]);

/**
 * Normalize Site API payload to sorted unique site name strings.
 * @param {unknown} payload
 * @returns {string[]}
 */
export function normalizeSiteNames(payload) {
  const rows = Array.isArray(payload)
    ? payload
    : (payload && Array.isArray(payload.results) ? payload.results : []);

  const names = rows
    .map((row) => {
      if (typeof row === 'string') return row.trim();
      if (row && row.name != null) return String(row.name).trim();
      return '';
    })
    .filter(Boolean);

  return Array.from(new Set(names)).sort((a, b) => a.localeCompare(b));
}

const siteOptions = {
  FALLBACK_ENTERPRISE_SITES,
  normalizeSiteNames,
};

export default siteOptions;
